import { Table } from '@material-ui/core'
import NumberFormat from 'react-number-format'
import { TableContainerCustomizado, TableRowVerde, TableCellBold, TableCellBoldAlignRight } from '../index.style'
import { DadosLoteadora } from 'models/Viabilidade/Loteadora'

const CartaoLoteadora: React.FC<{ dados: DadosLoteadora }> = ({ dados }) => {
  return (
    <TableContainerCustomizado>
      <Table data-cy="tableLoteadora">
        <TableRowVerde>
          <TableCellBold>Preço do Lote da Casa (R$/unid)</TableCellBold>
          <TableCellBoldAlignRight data-cy="campoPrecoLote">
            <NumberFormat value={dados.precoLote} displayType="text" thousandSeparator="." decimalSeparator="," defaultValue="-"></NumberFormat>
          </TableCellBoldAlignRight>
        </TableRowVerde>
      </Table>
    </TableContainerCustomizado>
  )
}

export default CartaoLoteadora
